import frontPhotoSample from "../../images/photo-front-sample.svg"
import leftPhotoSample from "../../images/photo-left-sample.svg"
import rightPhotoSample from "../../images/photo-right-sample.svg"

const PhotoSlot = ({ position, showPhotoPlaceholders = true, isModern }) => {
  const IMG_SRC = {
    front: frontPhotoSample,
    left: leftPhotoSample,
    right: rightPhotoSample,
  }

  return (
    <div sx={{ flex: 1, mx: [1, 2] }}>
      <div
        sx={{
          display: "block",
          position: "relative",
          pb: "100%",
          backgroundColor: isModern ? null : "grey",
        }}
      >
        {showPhotoPlaceholders && (
          <img
            src={IMG_SRC[position]}
            alt=""
            sx={{
              position: "absolute",
              width: "90%",
              height: "auto",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            loading="lazy"
          />
        )}
      </div>
    </div>
  )
}

export default PhotoSlot
